interface GetCDNResizedImageUrlParams {
  width?: number;
  height?: number;
  quality?: number;
  format?: "avif" | "webp" | "jpeg";
}

export const getCDNResizedImageUrl = (
  url: string,
  {
    width, // 기본값 cloudflare에서 처리
    height, // 기본값 cloudflare에서 처리
    quality, // 기본값 100 cloudflare에서 처리
    format, // 가능한 요청 cloudflare에서 인식하여 자동으로 처리
  }: GetCDNResizedImageUrlParams,
): string => {
  try {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);

    if (width) params.set("w", String(width));
    if (height) params.set("h", String(height));
    if (quality) params.set("q", String(quality));
    if (format) params.set("f", format);

    urlObj.search = params.toString();

    return urlObj.toString();
  } catch (error) {
    return url;
  }
};
